import React, { Component } from 'react';
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  Handle,
  Position,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { k3docService } from '../../services';
import { k3DocToFlow, flowToK3Doc } from '../../utils';
import { Button, Spinner, Toast, ToastContainer, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { FaEye, FaEdit } from 'react-icons/fa';
import { BsPencil } from 'react-icons/bs';
import IframeModal from '../../components/IframeModal';
import { getAIConversations, getK3Agents, getCommits, getAllCollections } from '../../actions';
import Select from 'react-select';
import ColorPicker from './ColorPicker';
import { Modal as RsModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Custom Node Component
const CustomNode = (props) => {
  const { data, isConnectable, node } = props;
  const handleViewClick = (e) => {
    console.log("CLICK NODE", data, data.onView);
    e.stopPropagation();
    if (!data.link) return;
    switch (data.viewMode) {
      case 'modal':
      case 'iframe':
        data.onView && data.onView(node);
        break;
      case 'tab':
      default:
        let link = data.link;
        if (!/^https?:\/\//i.test(link)) {
          if (!link.startsWith('/')) link = '/' + link;
          link = window.location.origin + link;
        }
        window.open(link, '_blank');
        break;
    }
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    data.onEdit && data.onEdit(node);
  };

  // Badge color by type, lấy từ localStorage nếu có
  const type = data.linkItemType || 'custom';
  const badgeColor = localStorage.getItem('cfg_badgeColor_' + type) || {
    conversation: '#007bff',
    agent: '#28a745',
    commit: '#ffc107',
    collection: '#6f42c1',
    custom: '#6c757d'
  }[type] || '#6c757d';

  // Lấy config handle từ localStorage
  const handleDiameter = Number(localStorage.getItem('cfg_handleDiameter')) || 18;
  const handleColor = localStorage.getItem('cfg_handleColor') || '#222222';
  const handleBorderColor = localStorage.getItem('cfg_handleBorderColor') || '#fff';

  return (
    <div
      className="custom-node position-relative"
      style={{
        padding: '7px 10px 10px 10px',
        border: `2px solid ${data.color || '#ddd'}`,
        borderRadius: '7px',
        background: data.fill || 'white',
        minWidth: 110,
        minHeight: 50,
        overflow: 'visible',
        position: 'relative',
        cursor: 'default',
        fontSize: '9.5px',
        color: '#222',
        boxShadow: data.color ? `0 0 0 2px ${data.color}33` : undefined,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      title={data.link ? `View in ${data.viewMode || 'tab'}` : ''}
      onClick={data.onEdit ? (e) => { e.stopPropagation(); data.onEdit(node); } : undefined}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        className="custom-handle-left"
        style={{
          width: handleDiameter,
          height: handleDiameter,
          minWidth: handleDiameter,
          minHeight: handleDiameter,
          maxWidth: handleDiameter,
          maxHeight: handleDiameter,
          background: handleColor,
          border: `2px solid ${handleBorderColor}`,
          boxShadow: '0 1px 2px #0002',
          zIndex: 1
        }}
      />
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        className="custom-handle-right"
        style={{
          width: handleDiameter,
          height: handleDiameter,
          minWidth: handleDiameter,
          minHeight: handleDiameter,
          maxWidth: handleDiameter,
          maxHeight: handleDiameter,
          background: handleColor,
          border: `2px solid ${handleBorderColor}`,
          boxShadow: '0 1px 2px #0002',
          zIndex: 1
        }}
      />
      <div style={{
        width: '100%',
        textAlign: 'center',
        fontWeight: 500,
        fontSize: '10px',
        marginBottom: 2,
        wordBreak: 'break-word',
        lineHeight: 1.2,
        minHeight: 15
      }}>{data.label}</div>
      {type && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          marginTop: 2
        }}>
          <span
            style={{
              background: badgeColor,
              color: 'white',
              borderRadius: 6,
              fontSize: 9,
              padding: '1.5px 6px',
              fontWeight: 600,
              letterSpacing: 0.2,
              margin: '0 auto',
              minWidth: 36,
              textAlign: 'center',
              boxShadow: '0 1px 2px #0001',
              cursor: data.link ? 'pointer' : 'default',
            }}
            title={data.link ? `View in ${data.viewMode || 'tab'}` : ''}
            onClick={data.link ? (e) => { e.stopPropagation(); handleViewClick(e); } : undefined}
          >
            {type}
          </span>
        </div>
      )}
    </div>
  );
};

function getQueryParam(name) {
  const url = window.location.search;
  const params = new URLSearchParams(url);
  return params.get(name);
}

class FlowViewOld extends Component {
  state = {
    k3Doc: null,
    flow: null,
    nodes: [],
    edges: [],
    loading: true,
    showToast: false,
    toastMessage: '',
    toastType: 'success',
    selectedNode: null,
    selectedEdge: null,
    showNodeModal: false,
    showEdgeModal: false,
    showPropertiesPanel: false,
    showViewModal: false,
    showIframeModal: false,
    viewNode: null,
    showEditModal: false,
    editingFlow: {
      title: '',
      friendlyVersion: '',
      description: ''
    },
    selectedType: 'conversation',
    selectedItem: '',
    autoFillTitle: localStorage.getItem('autoFillTitle') === 'true',
    showConfigModal: false,
    config: {
      nodeStroke: localStorage.getItem('cfg_nodeStroke') || '#dddddd',
      nodeFill: localStorage.getItem('cfg_nodeFill') || '#ffffff',
      nodeWidth: Number(localStorage.getItem('cfg_nodeWidth')) || 120,
      nodeHeight: Number(localStorage.getItem('cfg_nodeHeight')) || 60,
      handleColor: localStorage.getItem('cfg_handleColor') || '#222222',
      handleDiameter: Number(localStorage.getItem('cfg_handleDiameter')) || 18,
      handleBorderColor: localStorage.getItem('cfg_handleBorderColor') || '#fff',
      badgeColor_conversation: localStorage.getItem('cfg_badgeColor_conversation') || '#007bff',
      badgeColor_agent: localStorage.getItem('cfg_badgeColor_agent') || '#28a745',
      badgeColor_commit: localStorage.getItem('cfg_badgeColor_commit') || '#ffc107',
      badgeColor_collection: localStorage.getItem('cfg_badgeColor_collection') || '#6f42c1',
      badgeColor_custom: localStorage.getItem('cfg_badgeColor_custom') || '#6c757d',
      edgeColor_default: localStorage.getItem('cfg_edgeColor_default') || '#555',
      edgeColor_straight: localStorage.getItem('cfg_edgeColor_straight') || '#555',
      edgeColor_step: localStorage.getItem('cfg_edgeColor_step') || '#555',
      edgeColor_smoothstep: localStorage.getItem('cfg_edgeColor_smoothstep') || '#555',
      snapToGrid: localStorage.getItem('cfg_snapToGrid') === 'true',
    }
  };

  attachNodeHandlers = (nodes) => {
    return nodes.map(node => ({
      ...node,
      data: {
        ...node.data,
        onView: this.handleNodeView,
        onEdit: this.handleNodeEdit
      }
    }));
  };

  componentDidMount() {
    const mid = getQueryParam('mid');
    const id = getQueryParam('id');
    this.setState({ loading: true });

    if (this.state.flow && this.state.flow.title) {
      document.title = this.state.flow.title;
    } else {
      document.title = 'Flow View';
    }

    // Gọi các hàm lấy dữ liệu cho dropdown
    this.props.getAIConversations && this.props.getAIConversations();
    this.props.getK3Agents && this.props.getK3Agents();
    this.props.getCommits && this.props.getCommits();
    this.props.getAllCollections && this.props.getAllCollections();

    if (id) {
      k3docService.getK3Docs({ id })
        .then(res => {
          const docs = res.data.data.docs;
          const k3Doc = docs && docs.length > 0 ? docs[0] : null;
          const flow = k3Doc ? k3DocToFlow(k3Doc) : null;
          this.setState({
            k3Doc,
            flow,
            nodes: flow ? this.attachNodeHandlers(flow.nodes) : [],
            edges: flow ? flow.edges : [],
            loading: false
          });
        })
        .catch(() => this.setState({ loading: false }));
    } else if (mid) {
      k3docService.getK3Docs({ docMid: mid })
        .then(res => {
          const docs = res.data.data.docs;
          if (docs && docs.length > 0) {
            const k3Doc = docs[0];
            const flow = k3DocToFlow(k3Doc);
            this.setState({
              k3Doc,
              flow,
              nodes: flow ? this.attachNodeHandlers(flow.nodes) : [],
              edges: flow ? flow.edges : [],
              loading: false
            });
          } else {
            this.setState({ loading: false });
          }
        })
        .catch(() => this.setState({ loading: false }));
    } else {
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.state.flow && this.state.flow.title) !== (prevState.flow && prevState.flow.title)
    ) {
      document.title = this.state.flow && this.state.flow.title ? this.state.flow.title : 'Flow View';
    }
  }

  openConfigModal = () => this.setState({ showConfigModal: true });
  closeConfigModal = () => this.setState({ showConfigModal: false });

  handleConfigChange = (key, value) => {
    this.setState(prev => ({
      config: { ...prev.config, [key]: value }
    }));
  };

  saveConfig = () => {
    const { config } = this.state;
    localStorage.setItem('cfg_nodeStroke', config.nodeStroke);
    localStorage.setItem('cfg_nodeFill', config.nodeFill);
    localStorage.setItem('cfg_nodeWidth', config.nodeWidth);
    localStorage.setItem('cfg_nodeHeight', config.nodeHeight);
    localStorage.setItem('cfg_handleColor', config.handleColor);
    localStorage.setItem('cfg_handleDiameter', config.handleDiameter);
    localStorage.setItem('cfg_handleBorderColor', config.handleBorderColor);
    localStorage.setItem('cfg_badgeColor_conversation', config.badgeColor_conversation);
    localStorage.setItem('cfg_badgeColor_agent', config.badgeColor_agent);
    localStorage.setItem('cfg_badgeColor_commit', config.badgeColor_commit);
    localStorage.setItem('cfg_badgeColor_collection', config.badgeColor_collection);
    localStorage.setItem('cfg_badgeColor_custom', config.badgeColor_custom);
    localStorage.setItem('cfg_edgeColor_default', config.edgeColor_default);
    localStorage.setItem('cfg_edgeColor_straight', config.edgeColor_straight);
    localStorage.setItem('cfg_edgeColor_step', config.edgeColor_step);
    localStorage.setItem('cfg_edgeColor_smoothstep', config.edgeColor_smoothstep);
    localStorage.setItem('cfg_snapToGrid', config.snapToGrid);
    this.setState({ showConfigModal: false });
  };

  addNode = () => {
    const defaultViewMode = localStorage.getItem('defaultViewMode') || 'iframe';
    const cfg = this.state.config;
    let newNode = {
      id: `node-${Date.now()}`,
      type: 'custom',
      position: { x: 100, y: 100 },
      style: { width: cfg.nodeWidth, height: cfg.nodeHeight },
      data: {
        title: 'Node mới',
        label: 'Node mới',
        viewMode: defaultViewMode,
        link: '',
        content: '',
        color: cfg.nodeStroke,
        fill: cfg.nodeFill,
        onEdit: this.handleNodeEdit,
        onView: this.handleNodeView
      },
    };
    // Nếu có selectedNode thì đặt gần node đó và copy style
    if (this.state.selectedNode) {
      const refNode = this.state.selectedNode;
      newNode.position = {
        x: (refNode.position?.x || 0) + 60,
        y: (refNode.position?.y || 0) + 60
      };
      // Copy style/color/fill/viewMode nếu có
      if (refNode.data) {
        if (refNode.data.color) newNode.data.color = refNode.data.color;
        if (refNode.data.fill) newNode.data.fill = refNode.data.fill;
        if (refNode.data.viewMode) newNode.data.viewMode = refNode.data.viewMode;
        if (refNode.data.linkItemType) newNode.data.linkItemType = refNode.data.linkItemType;
      }
    }
    this.setState(prev => ({
      nodes: [...prev.nodes, newNode]
    }));
  };

  handleSave = () => {
    const { k3Doc, flow, nodes, edges } = this.state;
    if (!k3Doc) return;

    const newFlow = { ...flow, nodes, edges };

    console.log('newFlow', newFlow);

    const newK3Doc = flowToK3Doc(newFlow);

    console.log('newK3Doc', newK3Doc);

    const mid = getQueryParam('mid');
    const id = getQueryParam('id');

    let isNewVersion = false;
    let payload = { ...newK3Doc };
    delete payload.createdAt;
    delete payload.updatedAt;

    let options = {};
    if (mid) {
      isNewVersion = true;
      payload.doc_mid = k3Doc.doc_mid;
      delete payload._id;
      options.generate_version = true;
    } else if (id) {
      isNewVersion = false;
      payload._id = k3Doc._id;
      options.generate_version = false;
    }

    this.setState({ loading: true });
    k3docService.setK3Docs([payload], options)
      .then(() => {
        this.setState({
          k3Doc: { ...k3Doc, ...payload },
          flow: newFlow,
          showToast: true,
          toastMessage: 'Đã lưu flow lên server!',
          toastType: 'success',
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          showToast: true,
          toastMessage: 'Lỗi khi lưu flow lên server!',
          toastType: 'danger',
          loading: false
        });
      });
  };

  handleSaveAsNewVersion = () => {
    const { k3Doc, flow, nodes, edges } = this.state;
    if (!k3Doc) return;

    const newFlow = { ...flow, nodes, edges };
    const newK3Doc = flowToK3Doc(newFlow);

    let payload = { ...newK3Doc };
    delete payload.createdAt;
    delete payload.updatedAt;
    payload.doc_mid = k3Doc.doc_mid;
    delete payload._id;
    const options = { generate_version: true };

    this.setState({ loading: true });
    k3docService.setK3Docs([payload], options)
      .then(() => {
        this.setState({
          k3Doc: { ...k3Doc, ...payload },
          flow: newFlow,
          showToast: true,
          toastMessage: 'Đã lưu flow thành version mới!',
          toastType: 'success',
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          showToast: true,
          toastMessage: 'Lỗi khi lưu version mới!',
          toastType: 'danger',
          loading: false
        });
      });
  };

  onNodeClick = (event, node) => {
    event.preventDefault();
    event.stopPropagation();
    this.handleNodeEdit(node);
    this.setState({ showPropertiesPanel: false });
  };

  onNodeDoubleClick = (event, node) => {
    event.preventDefault();
    event.stopPropagation();
    this.handleNodeEdit(node);
    this.setState({ showPropertiesPanel: false });
  };

  handleNodeEdit = (node) => {
    // Lấy type và item từ node data nếu có
    const type = node.data.linkItemType || 'conversation';
    const item = node.data.linkItemId || '';
    this.setState({
      selectedNode: node,
      showNodeModal: true,
      selectedType: type,
      selectedItem: item
    });
  };

  handleNodeModalClose = () => {
    this.setState({
      showNodeModal: false,
      selectedNode: null,
      selectedType: 'conversation',
      selectedItem: ''
    });
  };

  handleNodeSave = () => {
    const { selectedNode, nodes } = this.state;
    if (!selectedNode) return;
    // Save recent colors (copy logic trực tiếp)
    if (selectedNode.data.color) {
      let recentNodeStrokeColors = [];
      try {
        recentNodeStrokeColors = JSON.parse(localStorage.getItem('recentNodeStrokeColors') || '[]');
      } catch {}
      if (!Array.isArray(recentNodeStrokeColors)) recentNodeStrokeColors = [];
      let arr = recentNodeStrokeColors.filter(c => c !== selectedNode.data.color);
      arr.unshift(selectedNode.data.color);
      if (arr.length > 8) arr = arr.slice(0, 8);
      localStorage.setItem('recentNodeStrokeColors', JSON.stringify(arr));
    }
    if (selectedNode.data.fill) {
      let recentNodeFillColors = [];
      try {
        recentNodeFillColors = JSON.parse(localStorage.getItem('recentNodeFillColors') || '[]');
      } catch {}
      if (!Array.isArray(recentNodeFillColors)) recentNodeFillColors = [];
      let arr = recentNodeFillColors.filter(c => c !== selectedNode.data.fill);
      arr.unshift(selectedNode.data.fill);
      if (arr.length > 8) arr = arr.slice(0, 8);
      localStorage.setItem('recentNodeFillColors', JSON.stringify(arr));
    }
    const updatedNodes = nodes.map(node => {
      if (node.id === selectedNode.id) {
        return {
          ...node,
          data: {
            ...node.data,
            ...selectedNode.data
          }
        };
      }
      return node;
    });

    console.log('updatedNodes', updatedNodes);

    this.setState({
      nodes: updatedNodes,
      showNodeModal: false,
      selectedNode: null
    }, () => {
      this.handleSave();
    });
  };

  handleNodePropertyChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => ({
      selectedNode: {
        ...prev.selectedNode,
        data: {
          ...prev.selectedNode.data,
          [name]: value
        }
      }
    }));
  };

  onNodesChange = (changes) => {
    const { nodes } = this.state;
    const newNodes = nodes.map(node => {
      const change = changes.find(c => c.id === node.id);
      if (change && change.type === 'position' && change.position) {
        return { ...node, position: change.position };
      }
      return node;
    });
    this.setState({ nodes: newNodes });
  };

  onEdgesChange = (changes) => {
    const { edges } = this.state;
    const newEdges = edges.map(edge => {
      const change = changes.find(c => c.id === edge.id);
      if (change) {
        return { ...edge, ...change };
      }
      return edge;
    });
    this.setState({ edges: newEdges });
  };

  onConnect = (params) => {
    const newEdge = {
      id: `edge-${Date.now()}`,
      source: params.source,
      target: params.target,
      type: 'default',
      animated: true,
      style: { stroke: this.state.config.edgeColor_default || '#555' }
    };

    this.setState(prev => ({
      edges: [...prev.edges, newEdge]
    }), () => {
      this.handleSave();
    });
  };

  onEdgesDelete = (edgesToDelete) => {
    this.setState(prev => ({
      edges: prev.edges.filter(edge => !edgesToDelete.find(e => e.id === edge.id))
    }), () => {
      this.handleSave();
    });
  };

  onEdgeClick = (event, edge) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      selectedEdge: edge,
      showEdgeModal: true
    });
  };

  handleEdgeModalClose = () => {
    this.setState({
      showEdgeModal: false,
      selectedEdge: null
    });
  };

  handleEdgeSave = () => {
    const { selectedEdge, edges } = this.state;
    if (!selectedEdge) return;
    // Save recent color (copy logic trực tiếp)
    if (selectedEdge.style && selectedEdge.style.stroke) {
      let recentEdgeColors = [];
      try {
        recentEdgeColors = JSON.parse(localStorage.getItem('recentEdgeColors') || '[]');
      } catch {}
      if (!Array.isArray(recentEdgeColors)) recentEdgeColors = [];
      let arr = recentEdgeColors.filter(c => c !== selectedEdge.style.stroke);
      arr.unshift(selectedEdge.style.stroke);
      if (arr.length > 8) arr = arr.slice(0, 8);
      localStorage.setItem('recentEdgeColors', JSON.stringify(arr));
    }
    const updatedEdges = edges.map(edge => {
      if (edge.id === selectedEdge.id) {
        return {
          ...edge,
          ...selectedEdge
        };
      }
      return edge;
    });

    this.setState({
      edges: updatedEdges,
      showEdgeModal: false,
      selectedEdge: null
    }, () => {
      this.handleSave();
    });
  };

  handleEdgePropertyChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => ({
      selectedEdge: {
        ...prev.selectedEdge,
        [name]: value
      }
    }));
  };

  handleNodeView = (node) => {
    console.log('node', node);
    if (node.data.viewMode === 'iframe') {
      this.setState({
        viewNode: node,
        showIframeModal: true
      });
    } else {
      this.setState({
        viewNode: node,
        showViewModal: true
      });
    }
  };

  handleViewModalClose = () => {
    this.setState({
      showViewModal: false,
      showIframeModal: false,
      viewNode: null
    });
  };

  handleEditFlow = () => {
    const { flow, k3Doc } = this.state;
    this.setState({
      showEditModal: true,
      editingFlow: {
        title: flow.title,
        friendlyVersion: k3Doc?.friendly_version || '',
        description: flow.description || ''
      }
    });
  };

  handleEditFlowChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => ({
      editingFlow: {
        ...prev.editingFlow,
        [name]: value
      }
    }));
  };

  handleEditFlowSave = async () => {
    const { k3Doc, flow, editingFlow } = this.state;
    if (!k3Doc) return;

    const updatedFlow = {
      ...flow,
      title: editingFlow.title,
      description: editingFlow.description
    };

    const newK3Doc = flowToK3Doc(updatedFlow);
    let payload = { ...newK3Doc };
    delete payload.createdAt;
    delete payload.updatedAt;
    payload.friendly_version = editingFlow.friendlyVersion;

    const mid = getQueryParam('mid');
    const id = getQueryParam('id');

    let options = {};
    if (mid) {
      payload.doc_mid = k3Doc.doc_mid;
      delete payload._id;
      options.generate_version = true;
    } else if (id) {
      payload._id = k3Doc._id;
      options.generate_version = false;
    }

    this.setState({ loading: true });
    try {
      await k3docService.setK3Docs([payload], options);
      this.setState({
        k3Doc: { ...k3Doc, ...payload },
        flow: updatedFlow,
        showToast: true,
        toastMessage: 'Đã cập nhật thông tin flow!',
        toastType: 'success',
        loading: false,
        showEditModal: false
      });
    } catch (error) {
      this.setState({
        showToast: true,
        toastMessage: 'Lỗi khi cập nhật thông tin flow!',
        toastType: 'danger',
        loading: false
      });
    }
  };

  handleEditModalClose = () => {
    this.setState({
      showEditModal: false,
      editingFlow: {
        title: '',
        friendlyVersion: '',
        description: ''
      }
    });
  };

  handleTypeChange = (e) => {
    this.setState({ selectedType: e.target.value, selectedItem: '' });
  };

  handleItemChange = (selectedOption) => {
    const { selectedType, autoFillTitle } = this.state;
    const val = selectedOption ? selectedOption.value : '';
    this.setState({ selectedItem: val });
    
    let found, linkVal = '', titleVal = '';
    if (selectedType === 'conversation') {
      found = this.props.aiConversations.find(i => i.conversation_id === val);
      if (found) {
        linkVal = `/v1/k3pl-chat?conversationId=${found.conversation_id}&show_menu=false`;
        titleVal = found.title || '';
      }
    } else if (selectedType === 'agent') {
      found = this.props.k3agents.find(i => i._id === val);
      if (found) {
        linkVal = `/v1/agent/view?id=${found._id}`;
        titleVal = found.name || '';
      }
    } else if (selectedType === 'commit') {
      found = this.props.commits.find(i => i._id === val);
      if (found) {
        linkVal = `/v1/commit/${found._id}`;
        titleVal = found.title || '';
      }
    } else if (selectedType === 'collection') {
      found = (this.props.collections || []).find(i => i._id === val);
      if (found) {
        linkVal = `/v1/collection/${found._id}`;
        titleVal = found.name || '';
      }
    }
    // Always set linkItemType and linkItemId
    this.handleNodePropertyChange({ target: { name: 'linkItemType', value: selectedType } });
    this.handleNodePropertyChange({ target: { name: 'linkItemId', value: val } });
    if (linkVal) {
      this.handleNodePropertyChange({ target: { name: 'link', value: linkVal } });
    }
    if (autoFillTitle && titleVal) {
      this.handleNodePropertyChange({ target: { name: 'title', value: titleVal } });
      this.handleNodePropertyChange({ target: { name: 'label', value: titleVal } });
    }
  };

  handleAutoFillTitleChange = (e) => {
    const checked = e.target.checked;
    this.setState({ autoFillTitle: checked });
    localStorage.setItem('autoFillTitle', checked);

    // If checked, try to fill the title based on current selection
    if (checked && this.state.selectedItem) {
      const { selectedType } = this.state;
      let titleVal = '';
      
      if (selectedType === 'conversation') {
        const found = this.props.aiConversations.find(i => i.conversation_id === this.state.selectedItem);
        if (found) titleVal = found.title || '';
      } else if (selectedType === 'agent') {
        const found = this.props.k3agents.find(i => i._id === this.state.selectedItem);
        if (found) titleVal = found.name || '';
      } else if (selectedType === 'commit') {
        const found = this.props.commits.find(i => i._id === this.state.selectedItem);
        if (found) titleVal = found.title || '';
      } else if (selectedType === 'collection') {
        const found = (this.props.collections || []).find(i => i._id === this.state.selectedItem);
        if (found) titleVal = found.name || '';
      }

      if (titleVal) {
        this.handleNodePropertyChange({ target: { name: 'title', value: titleVal } });
      }
    }
  };

  renderNodeModal = () => {
    const { selectedNode, showNodeModal, selectedType, selectedItem, autoFillTitle, nodes, edges } = this.state;
    if (!selectedNode) return null;

    // Dropdown options
    const typeOptions = [
      { value: 'conversation', label: 'Conversation' },
      { value: 'agent', label: 'Agent' },
      { value: 'commit', label: 'Commit' },
      { value: 'collection', label: 'Collection' },
      { value: 'custom', label: 'Custom' },
    ];

    let itemOptions = [];
    if (selectedType === 'conversation') {
      itemOptions = (this.props.aiConversations || []).map(i => ({ value: i.conversation_id, label: i.title || i.conversation_id }));
    } else if (selectedType === 'agent') {
      itemOptions = (this.props.k3agents || []).map(i => ({ value: i._id, label: i.name }));
    } else if (selectedType === 'commit') {
      itemOptions = (this.props.commits || []).map(i => ({ value: i._id, label: i.title }));
    } else if (selectedType === 'collection') {
      itemOptions = (this.props.collections || []).map(i => ({ value: i._id, label: i.name }));
    }

    // Recent node colors from localStorage
    let recentNodeStrokeColors = [];
    let recentNodeFillColors = [];
    try {
      recentNodeStrokeColors = JSON.parse(localStorage.getItem('recentNodeStrokeColors') || '[]');
      recentNodeFillColors = JSON.parse(localStorage.getItem('recentNodeFillColors') || '[]');
    } catch {}
    if (!Array.isArray(recentNodeStrokeColors)) recentNodeStrokeColors = [];
    if (!Array.isArray(recentNodeFillColors)) recentNodeFillColors = [];
    const addRecentNodeStrokeColor = (color) => {
      let arr = recentNodeStrokeColors.filter(c => c !== color);
      arr.unshift(color);
      if (arr.length > 8) arr = arr.slice(0, 8);
      localStorage.setItem('recentNodeStrokeColors', JSON.stringify(arr));
    };
    const addRecentNodeFillColor = (color) => {
      let arr = recentNodeFillColors.filter(c => c !== color);
      arr.unshift(color);
      if (arr.length > 8) arr = arr.slice(0, 8);
      localStorage.setItem('recentNodeFillColors', JSON.stringify(arr));
    };

    return (
      <RsModal isOpen={showNodeModal} toggle={this.handleNodeModalClose} size="lg" className="modal-dialog-centered">
        <ModalHeader toggle={this.handleNodeModalClose} className="position-relative" style={{alignItems: 'center'}}>
          <span>Edit Node</span>
          <div
            className="d-flex gap-2"
            style={{
              position: 'absolute',
              right: 56,
              top: 18,
              zIndex: 2
            }}
          >
            <Button variant="primary" onClick={this.handleNodeSave}>Save Changes</Button>
            <Button variant="danger" onClick={() => {
              // Xóa node và các edge liên quan
              const nodeId = selectedNode.id;
              const newNodes = nodes.filter(n => n.id !== nodeId);
              const newEdges = edges.filter(e => e.source !== nodeId && e.target !== nodeId);
              this.setState({
                nodes: newNodes,
                edges: newEdges,
                showNodeModal: false,
                selectedNode: null
              }, () => {
                this.handleSave();
              });
            }}>Delete Node</Button>
          </div>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={selectedNode.data.title || ''}
                onChange={this.handleNodePropertyChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Label</Form.Label>
              <Form.Control
                type="text"
                name="label"
                value={selectedNode.data.label || ''}
                onChange={this.handleNodePropertyChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <div className="d-flex" style={{gap: 16}}>
                <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 0}}>
                  <ColorPicker
                    label="Node Stroke Color"
                    value={selectedNode.data.color || '#dddddd'}
                    recentColors={recentNodeStrokeColors}
                    onChange={color => this.handleNodePropertyChange({target: {name: 'color', value: color}})}
                    name="color"
                  />
                </Form.Group>
                <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 0}}>
                  <ColorPicker
                    label="Node Fill Color"
                    value={selectedNode.data.fill || '#ffffff'}
                    recentColors={recentNodeFillColors}
                    onChange={color => this.handleNodePropertyChange({target: {name: 'fill', value: color}})}
                    name="fill"
                  />
                </Form.Group>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Node Link</Form.Label>
              <div className="border rounded p-3">
                <div className="row mb-3">
                  <div className="col">
                    <Form.Label>Type</Form.Label>
                    <Select
                      options={typeOptions}
                      value={typeOptions.find(option => option.value === selectedType)}
                      onChange={(option) => {
                        this.setState({ selectedType: option.value, selectedItem: '' });
                        this.handleNodePropertyChange({ target: { name: 'link', value: '' } });
                        this.handleNodePropertyChange({ target: { name: 'linkItemType', value: '' } });
                        this.handleNodePropertyChange({ target: { name: 'linkItemId', value: '' } });
                      }}
                      isSearchable
                    />
                  </div>
                  {selectedType !== 'custom' && (
                    <div className="col">
                      <Form.Label>Select Item</Form.Label>
                      <Select
                        options={itemOptions}
                        value={itemOptions.find(option => String(option.value) === String(selectedItem)) || null}
                        onChange={this.handleItemChange}
                        isSearchable
                        placeholder="Select ..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            width: '100%',
                            fontSize: '0.875rem',
                            borderRadius: '0.25rem'
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            width: '100%',
                            padding: '0 6px'
                          }),
                          input: (base) => ({
                            ...base,
                            margin: '0px',
                            width: '100%'
                          }),
                          indicatorsContainer: (base) => ({
                            ...base
                          })
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <Form.Label>View Mode</Form.Label>
                    <Form.Select
                      name="viewMode"
                      value={selectedNode.data.viewMode || 'modal'}
                      onChange={e => {
                        this.handleNodePropertyChange(e);
                        localStorage.setItem('defaultViewMode', e.target.value);
                      }}
                    >
                      <option value="modal">Modal</option>
                      <option value="tab">Tab</option>
                      <option value="iframe">Iframe</option>
                    </Form.Select>
                  </div>
                  <div className="col d-flex align-items-end">
                    <Form.Check
                      type="checkbox"
                      label="Auto Fill Title"
                      checked={autoFillTitle}
                      onChange={this.handleAutoFillTitleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="text"
                      name="link"
                      value={selectedNode.data.link || ''}
                      onChange={this.handleNodePropertyChange}
                      disabled={selectedType !== 'custom' ? !!selectedType : false}
                    />
                  </div>
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                name="content"
                value={selectedNode.data.content || ''}
                onChange={this.handleNodePropertyChange}
                rows={5}
              />
            </Form.Group>
          </Form>
        </ModalBody>
      </RsModal>
    );
  };

  renderEdgeModal = () => {
    const { selectedEdge, showEdgeModal } = this.state;
    if (!selectedEdge) return null;

    // Recent edge colors from localStorage
    let recentEdgeColors = [];
    try {
      recentEdgeColors = JSON.parse(localStorage.getItem('recentEdgeColors') || '[]');
    } catch {}
    if (!Array.isArray(recentEdgeColors)) recentEdgeColors = [];
    const addRecentEdgeColor = (color) => {
      let arr = recentEdgeColors.filter(c => c !== color);
      arr.unshift(color);
      if (arr.length > 8) arr = arr.slice(0, 8);
      localStorage.setItem('recentEdgeColors', JSON.stringify(arr));
    };

    // Get edge color from style
    let edgeColor = '#555';
    if (selectedEdge.style && selectedEdge.style.stroke) {
      edgeColor = selectedEdge.style.stroke;
    }

    return (
      <RsModal isOpen={showEdgeModal} toggle={this.handleEdgeModalClose} size="lg" className="modal-dialog-centered">
        <ModalHeader toggle={this.handleEdgeModalClose}>Edit Edge</ModalHeader>
        <ModalBody>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Select
                name="type"
                value={selectedEdge.type || 'default'}
                onChange={this.handleEdgePropertyChange}
              >
                <option value="default">Default</option>
                <option value="straight">Straight</option>
                <option value="step">Step</option>
                <option value="smoothstep">Smooth Step</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Animated</Form.Label>
              <Form.Check
                type="switch"
                name="animated"
                checked={selectedEdge.animated}
                onChange={(e) => this.handleEdgePropertyChange({
                  target: { name: 'animated', value: e.target.checked }
                })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Style</Form.Label>
              <Form.Control
                type="text"
                name="style"
                value={selectedEdge.style ? JSON.stringify(selectedEdge.style) : '{}'}
                onChange={(e) => {
                  try {
                    const style = JSON.parse(e.target.value);
                    this.handleEdgePropertyChange({
                      target: { name: 'style', value: style }
                    });
                  } catch (err) {
                    // Invalid JSON, ignore
                  }
                }}
                placeholder='{"stroke": "#555", "strokeWidth": 2}'
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <ColorPicker
                label="Edge Stroke Color"
                value={edgeColor}
                recentColors={recentEdgeColors}
                onChange={color => {
                  let style = selectedEdge.style ? {...selectedEdge.style} : {};
                  style.stroke = color;
                  this.handleEdgePropertyChange({target: {name: 'style', value: style}});
                }}
                onRecentColor={color => {
                  let style = selectedEdge.style ? {...selectedEdge.style} : {};
                  style.stroke = color;
                  this.handleEdgePropertyChange({target: {name: 'style', value: style}});
                }}
                name="edgeColor"
              />
            </Form.Group>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button variant="danger" onClick={() => {
            this.setState(prev => ({
              edges: prev.edges.filter(edge => edge.id !== selectedEdge.id),
              showEdgeModal: false,
              selectedEdge: null
            }), () => {
              this.handleSave();
            });
          }}>
            Delete Edge
          </Button>
          <Button variant="secondary" onClick={this.handleEdgeModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleEdgeSave}>
            Save Changes
          </Button>
        </ModalFooter>
      </RsModal>
    );
  };

  renderPropertiesPanel = () => {
    const { selectedNode, showPropertiesPanel } = this.state;
    if (!showPropertiesPanel || !selectedNode) return null;

    return (
      <div className="position-fixed end-0 top-0 h-100 bg-light p-3" style={{ width: '300px', zIndex: 1000 }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>Node Properties</h5>
          <Button variant="outline-primary" size="sm" onClick={() => this.handleNodeEdit(selectedNode)}>
            Edit
          </Button>
        </div>
        <div className="small">
          <div className="mb-2">
            <strong>Title:</strong> {selectedNode.data.title}
          </div>
          <div className="mb-2">
            <strong>Label:</strong> {selectedNode.data.label}
          </div>
          <div className="mb-2">
            <strong>View Mode:</strong> {selectedNode.data.viewMode}
          </div>
          <div className="mb-2">
            <strong>Link:</strong> {selectedNode.data.link || '-'}
          </div>
        </div>
      </div>
    );
  };

  renderViewModal = () => {
    const { viewNode, showViewModal } = this.state;
    if (!viewNode || !showViewModal) return null;

    return (
      <RsModal isOpen={showViewModal} toggle={this.handleViewModalClose} size="lg" className="modal-dialog-centered">
        <ModalHeader toggle={this.handleViewModalClose}>{viewNode.data.title}</ModalHeader>
        <ModalBody>
          <div>
            <h5>Content:</h5>
            <div>{viewNode.data.content}</div>
            {viewNode.data.link && (
              <div className="mt-3">
                <h5>Link:</h5>
                <a href={viewNode.data.link} target="_blank" rel="noopener noreferrer">
                  {viewNode.data.link}
                </a>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={this.handleViewModalClose}>
            Close
          </Button>
        </ModalFooter>
      </RsModal>
    );
  };

  renderEditModal = () => {
    const { showEditModal, editingFlow } = this.state;
    if (!showEditModal) return null;

    return (
      <RsModal isOpen={showEditModal} toggle={this.handleEditModalClose} size="lg" className="modal-dialog-centered">
        <ModalHeader toggle={this.handleEditModalClose}>Chỉnh sửa thông tin Flow</ModalHeader>
        <ModalBody>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Tiêu đề</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={editingFlow.title}
                onChange={this.handleEditFlowChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Friendly Version</Form.Label>
              <Form.Control
                type="text"
                name="friendlyVersion"
                value={editingFlow.friendlyVersion}
                onChange={this.handleEditFlowChange}
                placeholder="Ví dụ: v1.0.0"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mô tả</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                value={editingFlow.description}
                onChange={this.handleEditFlowChange}
                rows={3}
              />
            </Form.Group>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={this.handleEditModalClose}>
            Hủy
          </Button>
          <Button variant="primary" onClick={this.handleEditFlowSave}>
            Lưu thay đổi
          </Button>
        </ModalFooter>
      </RsModal>
    );
  };

  renderConfigModal = () => {
    const { showConfigModal, config } = this.state;
    return (
      <RsModal isOpen={showConfigModal} toggle={this.closeConfigModal} size="xl" className="modal-dialog-centered" style={{minWidth: '90vw', maxWidth: '95vw', margin: '0 auto'}}>
        <ModalHeader toggle={this.closeConfigModal}>Cấu hình Flow</ModalHeader>
        <ModalBody>
          <Form>
            <div className="mb-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }}>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 260}}>
                <ColorPicker
                  label="Màu viền node mặc định"
                  value={config.nodeStroke}
                  onChange={color => this.handleConfigChange('nodeStroke', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 260}}>
                <ColorPicker
                  label="Màu nền node mặc định"
                  value={config.nodeFill}
                  onChange={color => this.handleConfigChange('nodeFill', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 260}}>
                <ColorPicker
                  label="Màu handle mặc định"
                  value={config.handleColor}
                  onChange={color => this.handleConfigChange('handleColor', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 260}}>
                <ColorPicker
                  label="Màu viền handle"
                  value={config.handleBorderColor}
                  onChange={color => this.handleConfigChange('handleBorderColor', color)}
                />
              </Form.Group>
            </div>
            <div className="d-flex flex-wrap mt-4" style={{gap: 24}}>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Badge Conversation"
                  value={config.badgeColor_conversation}
                  onChange={color => this.handleConfigChange('badgeColor_conversation', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Badge Agent"
                  value={config.badgeColor_agent}
                  onChange={color => this.handleConfigChange('badgeColor_agent', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Badge Commit"
                  value={config.badgeColor_commit}
                  onChange={color => this.handleConfigChange('badgeColor_commit', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Badge Collection"
                  value={config.badgeColor_collection}
                  onChange={color => this.handleConfigChange('badgeColor_collection', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Badge Custom"
                  value={config.badgeColor_custom}
                  onChange={color => this.handleConfigChange('badgeColor_custom', color)}
                />
              </Form.Group>
            </div>
            <div className="d-flex flex-wrap mt-4" style={{gap: 24}}>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Edge Color Default"
                  value={config.edgeColor_default || '#555'}
                  onChange={color => this.handleConfigChange('edgeColor_default', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Edge Color Straight"
                  value={config.edgeColor_straight || '#555'}
                  onChange={color => this.handleConfigChange('edgeColor_straight', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Edge Color Step"
                  value={config.edgeColor_step || '#555'}
                  onChange={color => this.handleConfigChange('edgeColor_step', color)}
                />
              </Form.Group>
              <Form.Group className="mb-3 flex-fill" style={{flex: 1, minWidth: 220}}>
                <ColorPicker
                  label="Edge Color Smoothstep"
                  value={config.edgeColor_smoothstep || '#555'}
                  onChange={color => this.handleConfigChange('edgeColor_smoothstep', color)}
                />
              </Form.Group>
            </div>
            <div className="d-flex flex-wrap mt-4" style={{gap: 24}}>
              <Form.Group className="mb-3" style={{minWidth: 220}}>
                <Form.Label>Kích thước node (px)</Form.Label>
                <div className="d-flex" style={{gap: 8}}>
                  <Form.Control
                    type="number"
                    min={60}
                    max={400}
                    value={config.nodeWidth}
                    onChange={e => this.handleConfigChange('nodeWidth', Number(e.target.value))}
                    style={{width: 90}}
                    placeholder="Width"
                  />
                  <Form.Control
                    type="number"
                    min={30}
                    max={200}
                    value={config.nodeHeight}
                    onChange={e => this.handleConfigChange('nodeHeight', Number(e.target.value))}
                    style={{width: 90}}
                    placeholder="Height"
                  />
                </div>
              </Form.Group>
              <Form.Group className="mb-3" style={{minWidth: 220}}>
                <Form.Label>Đường kính handle (px)</Form.Label>
                <Form.Control
                  type="number"
                  min={8}
                  max={40}
                  value={config.handleDiameter}
                  onChange={e => this.handleConfigChange('handleDiameter', Number(e.target.value))}
                  style={{width: 90}}
                />
              </Form.Group>
            </div>
            <Form.Group className="mb-3">
              <Form.Label>Cover Image</Form.Label>
              <Form.Control
                type="text"
                name="cover_image"
                value={config.cover_image || ''}
                onChange={e => this.handleConfigChange('cover_image', e.target.value)}
                placeholder="Nhập URL hoặc đường dẫn ảnh cover..."
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Snap to Grid"
                checked={config.snapToGrid}
                onChange={e => this.handleConfigChange('snapToGrid', e.target.checked)}
              />
            </Form.Group>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={this.closeConfigModal}>Hủy</Button>
          <Button variant="primary" onClick={this.saveConfig}>Lưu cấu hình</Button>
        </ModalFooter>
      </RsModal>
    );
  };

  render() {
    const { flow, nodes, edges, loading, showToast, toastMessage, toastType, showNodeModal, viewNode, showIframeModal, showConfigModal } = this.state;
    if (loading) return <div>Loading...</div>;
    if (!flow) return <div>Không tìm thấy flow</div>;

    const nodeTypes = {
      custom: (nodeProps) => <CustomNode {...nodeProps} node={nodeProps} />
    };

    return (
      <div className="container-fluid p-4" style={{ height: '100%' }}>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h3 className="mt-0">{flow.title}</h3>
            <div className="text-muted small">
              <div>Version: {this.state.k3Doc?.version || '-'} {this.state.k3Doc?.friendly_version ? `(${this.state.k3Doc?.friendly_version})` : ''}</div>
              <div>Last Updated: {this.state.k3Doc?.updatedAt ? new Date(this.state.k3Doc.updatedAt).toLocaleString() : '-'}</div>
            </div>
          </div>
          <div>
            <Button className="me-2" variant="outline-secondary" onClick={this.openConfigModal}>Cấu hình</Button>
            <Button className="me-2" onClick={this.handleEditFlow}>Chỉnh sửa thông tin</Button>
            <Button className="me-2" onClick={this.addNode}>Thêm Node</Button>
            <Button variant="success" onClick={this.handleSave}>Lưu Flow</Button>
            {getQueryParam('id') && !getQueryParam('mid') && (
              <Button variant="warning" className="ms-2" onClick={this.handleSaveAsNewVersion}>Lưu Version mới</Button>
            )}
          </div>
        </div>

        <div style={{ width: '100%', height: '90%', marginTop: 16 }}>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            nodeTypes={nodeTypes}
            onNodesChange={this.onNodesChange}
            onEdgesChange={this.onEdgesChange}
            onConnect={this.onConnect}
            onEdgesDelete={this.onEdgesDelete}
            onEdgeClick={this.onEdgeClick}
            onNodeClick={this.onNodeClick}
            onNodeDoubleClick={this.onNodeDoubleClick}
            nodesDraggable={true}
            elementsSelectable={true}
            fitView
            defaultEdgeOptions={{
              type: 'default',
              animated: true,
              style: { stroke: '#555' }
            }}
            snapToGrid={this.state.config.snapToGrid}
          >
            <MiniMap />
            <Controls />
            <Background />
          </ReactFlow>
        </div>

        <ToastContainer position="top-end" className="p-3">
          <Toast
            show={showToast}
            onClose={() => this.setState({ showToast: false })}
            bg={toastType}
            delay={3000}
            autohide
          >
            <Toast.Body className="text-white">
              {toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
        {this.renderNodeModal()}
        {this.renderEdgeModal()}
        {this.renderViewModal()}
        {this.renderEditModal()}
        {this.renderConfigModal()}
        {viewNode && (
          <IframeModal
            show={showIframeModal}
            onHide={this.handleViewModalClose}
            url={viewNode.data.link}
            title={viewNode.data.title}
            showSidebar={false}
            style={{ zIndex: 10000 }}
          />
        )}
        {!showNodeModal && this.renderPropertiesPanel()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  aiConversations: state.aiConversationReducer.aiConversations || [],
  k3agents: state.k3agentReducer.k3agents || [],
  commits: state.commitReducer.commits || [],
  collections: state.collectionReducer.collections || []
});

export default connect(mapStateToProps, {
  getAIConversations,
  getK3Agents,
  getCommits,
  getAllCollections
})(FlowViewOld); 